import { z } from 'zod'

export const rejectRewardTicketSchema = z.object({
  reject_reason: z.string().min(16, { message: 'Mínimo de 16 caracteres' }).max(1024, 'Máximo de 1024 caracteres'),
})

export type RejectRewardTicketValidationSchema = z.infer<typeof rejectRewardTicketSchema>
